import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { svgBookmark } from '../../utility/BookmarkIcon';
import './styles.scss';

const svgIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <g fill="none" fillRule="evenodd" stroke="#1E1E1E">
      <path
        className="outer"
        d="M16 .5a15.5 15.5 0 1 0 0 31 15.5 15.5 0 0 0 0-31z"
      />
      <path
        className="inner"
        fill="#FFF"
        strokeWidth="1"
        d="M16 4.8a11.2 11.2 0 1 0 0 22.4 11.2 11.2 0 0 0 0-22.4z"
      />
    </g>
  </svg>
);

/**
 * Renders a question overview icon
 * */
class OverviewIcon extends PureComponent {
  static displayName = 'OverviewIcon';

  static defaultProps = {
    hasConnection: true,
    hasPrevConnection: false,
    isSelected: false,
    isAnswered: false,
    isBookmarked: false,
    isLast: false,
    isMobile: false,
    closeMenuContent: null,
    keyDownHandler: () => {},
  };

  static propTypes = {
    onClick: PropTypes.func.isRequired,
    keyDownHandler: PropTypes.func,
    reference: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    hasConnection: PropTypes.bool,
    hasPrevConnection: PropTypes.bool,
    isSelected: PropTypes.bool,
    isAnswered: PropTypes.bool,
    isBookmarked: PropTypes.bool,
    isLast: PropTypes.bool,
    /**
     * Flag for displaying desktop view or mobile view icon.
     * The submit button icon is different on desktop vs mobile.
     * */
    isMobile: PropTypes.bool,
    /**
     * Handler for closing the questions menu and the main menu.
     * */
    closeMenuContent: PropTypes.func,
  };

  /**
   * Icon on click event handler
   * @params {object} The click even handler
   * */
  onClick = (event) => {
    const { isMobile, reference, onClick, closeMenuContent } = this.props;

    onClick(event, reference);

    if (isMobile) {
      closeMenuContent();
    }
  };

  /**
   * Icon on key down event handler
   * @params {object} The click even handler
   * */
  keyDownHandler = (event) => {
    const { reference, keyDownHandler } = this.props;
    keyDownHandler(event, reference);
  };

  render() {
    const {
      isAnswered,
      isSelected,
      isBookmarked,
      hasConnection,
      hasPrevConnection,
      index,
      isMobile,
      reference,
    } = this.props;

    const className = cn(
      'overview-icon-container',
      isSelected ? 'is-selected' : '',
      isAnswered ? 'is-answered' : '',
      isBookmarked ? 'is-bookmarked' : '',
    );

    return (
      <div className={className}>
        {hasPrevConnection && <div className="overview-icon-connector" />}
        {(isMobile && (
          <div
            role="button"
            className="mobile-overview"
            tabIndex="0"
            onClick={this.onClick}
            aria-label={`Question ${index} ${
              isBookmarked ? '- Bookmarked' : ''
            }`}
            onKeyDown={this.keyDownHandler}
          >
            <div className="mobile-overview-data">
              <div className="mobile-overview-data-icon">
                <div className="mobile-overview-data-selected" />
              </div>
              <div className="mobile-overview-data-question">
                Question {index}
              </div>
            </div>
            {isBookmarked && (
              <div className="mobile-overview-bookmark">{svgBookmark}</div>
            )}
          </div>
        )) || (
          <Fragment>
            <button
              onClick={this.onClick}
              className="overview-icon"
              tabIndex={isSelected ? '0' : '-1'}
              role="tab"
              aria-label={`Question ${index} ${
                isBookmarked ? '- Bookmarked' : ''
              } ${isAnswered ? 'Answered' : ''}`}
              aria-selected={isSelected}
              onKeyDown={this.keyDownHandler}
              aria-current={isSelected}
              id={`question-nav-${reference}`}
            >
              {svgIcon}
              <span className="overview-icon-index">{index}</span>
            </button>
            <div className={cn('bookmarked-icon', { visible: isBookmarked })}>
              {svgBookmark}
            </div>
          </Fragment>
        )}
        {hasConnection ? (
          <div className="overview-icon-connector" />
        ) : (
          <div className="overview-icon-no-connector" />
        )}
      </div>
    );
  }
}

export default OverviewIcon;
